import {
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  csx,
  useCheckboxState,
  useRadioState,
} from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'

import type { Weekday } from 'typings'
import { useFormStateContext } from '../../../providers'
import { CRON_WEEKDAYS } from './cron'
import { messages } from './messages'

export const WEEKDAYS = Object.keys(CRON_WEEKDAYS) as Weekday[]

type Props = {
  name: string
}

export function Weekdays(props: Props) {
  const { name } = props
  const { formatMessage } = useIntl()
  const { form } = useFormStateContext()
  const weekdays: Weekday[] =
    useWatch({
      form,
      name,
    }) ?? []

  const state = useRadioState({
    defaultValue: weekdays.length ? 'specific' : 'any',
  })

  const weekdaysState = useCheckboxState({ initialValue: weekdays })

  const cleanUpValues = () => {
    form.setValue(name, [])
    form.clearErrors(name)
  }

  useEffect(() => {
    form.setValue(name, weekdaysState.value)
  }, [form, name, weekdaysState.value])

  return (
    <RadioGroup
      state={state}
      label={formatMessage(messages.weekdays)}
      className={csx({ marginY: '$space-5' })}
    >
      <Radio
        label={formatMessage(messages.allWeekdays)}
        value="any"
        onChange={cleanUpValues}
      />

      <Radio
        label={formatMessage(messages.specificWeekdays)}
        value="specific"
      />

      {state.value === 'specific' ? (
        <div
          className={csx({
            marginLeft: '$space-7',
            marginTop: '0.5rem !important',
          })}
        >
          <CheckboxGroup label="">
            {WEEKDAYS.map((weekday) => (
              <Checkbox
                value={weekday}
                key={weekday}
                label={formatMessage(messages[weekday])}
                state={weekdaysState}
              />
            ))}
          </CheckboxGroup>
        </div>
      ) : null}
    </RadioGroup>
  )
}
